import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'Join Winners Mindset';
render(<App data-id="element-1" />, document.getElementById('root'));